import { configureStore } from '@reduxjs/toolkit';
import reducer from './reducers';

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleWare) => getDefaultMiddleWare({
        serializableCheck: false,
        immutableCheck: false,
    }),
});

export default store;

export type Rootstate = ReturnType<typeof store.getState>
